// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doctor-retention-container {
    padding: 10px;
}

.dashboard-header {
    display: flex;
    justify-content: space-between;
}

.dashboard-title {
    font-size: 18px;
    margin-left: 10px;
    margin-top: 10px;
}

.filter-container {
    display: flex;
    border: 2px solid var(--primary-color);
    height: 40px;
    width: 140px;
    margin-right: 10px;
    border-radius: 12px;
    cursor: pointer;
    margin-top: 10px;
}

.filter-container-number {
    display: flex;
    border: 2px solid var(--primary-color);
    height: 40px;
    width: 240px;
    margin-right: 10px;
    border-radius: 12px;
    cursor: pointer;
    margin-top: 10px;
}

.filter-option {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 1;
    border-radius: 8px;
    color: black;
}

.filter-option.active {
    background-color: var(--primary-color);
    color: white;
}

.table-container {
    overflow-x: auto;
    border: 1px solid #ccc;
    max-height: 550px;
    margin: 15px 10px;
    width: 100%;
}

.retention-table {
    width: 100%;
    border-collapse: collapse;
}

.retention-table th,
.retention-table td {
    padding: 8px;
    text-align: center;
    border: 1px solid black;
}

.retention-table th {
    background-color: var(--primary-color);
    color: white;
    position: sticky;
    top: 0;
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/pages/doctor-retention/doctor-retention.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd","sourcesContent":[".doctor-retention-container {\n    padding: 10px;\n}\n\n.dashboard-header {\n    display: flex;\n    justify-content: space-between;\n}\n\n.dashboard-title {\n    font-size: 18px;\n    margin-left: 10px;\n    margin-top: 10px;\n}\n\n.filter-container {\n    display: flex;\n    border: 2px solid var(--primary-color);\n    height: 40px;\n    width: 140px;\n    margin-right: 10px;\n    border-radius: 12px;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.filter-container-number {\n    display: flex;\n    border: 2px solid var(--primary-color);\n    height: 40px;\n    width: 240px;\n    margin-right: 10px;\n    border-radius: 12px;\n    cursor: pointer;\n    margin-top: 10px;\n}\n\n.filter-option {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex: 1;\n    border-radius: 8px;\n    color: black;\n}\n\n.filter-option.active {\n    background-color: var(--primary-color);\n    color: white;\n}\n\n.table-container {\n    overflow-x: auto;\n    border: 1px solid #ccc;\n    max-height: 550px;\n    margin: 15px 10px;\n    width: 100%;\n}\n\n.retention-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.retention-table th,\n.retention-table td {\n    padding: 8px;\n    text-align: center;\n    border: 1px solid black;\n}\n\n.retention-table th {\n    background-color: var(--primary-color);\n    color: white;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
